module.exports = __webpack_public_path__ + "img/maestro.1a1037ee.svg";